module.exports = __webpack_public_path__ + "static/media/image-search1.c0026173.gif";